import { ConvexReactClient } from "convex/react";

const convexUrl = import.meta.env.VITE_CONVEX_URL;

export const convex = convexUrl ? new ConvexReactClient(convexUrl) : null;

// Always use relative URL — Vite proxy forwards /api/* to the Worker in dev,
// and the Worker itself serves the SPA in production (same-origin).
export const WORKER_URL = "";

export const isConvexEnabled = !!convexUrl;
